import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import './LoginForm.css';
import { useAuth } from '../../../../context/AuthContext';
import { config } from '../../../../config';

const LoginForm = () => {
    const navigate = useNavigate();
    const { login } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { id, value } = e.target;
        if (id === 'userName') {
            setEmail(value);
        } else if (id === 'password') {
            setPassword(value);
        }
    }

    const handleSubmitClick = async (e) => {
        e.preventDefault();
        if (!email || !password) {
            alert('Please fill in all fields');
            return;
        }
        try {
            setLoading(true);
            // For customer login, use email as username
            const loginPayload = {
                username: email,
                password: password,
                loginType: 'customer'
            };
            const response = await axios.post(`${config.API_BASE}/api/signin`, loginPayload);
            if (response.status === 200 && response.data) {
                const { user, token } = response.data;
                if (user && token) {
                    login(user, token);
                    alert('Login successful!');
                    
                    // Redirect based on role and subscription status
                    console.log('User object received:', user);
                    console.log('User role:', user.role);
                    console.log('User subscriptionStatus:', user.subscriptionStatus);
                    
                    if (user.role === "MANAGER") {
                        console.log('Redirecting to manager dashboard');
                        navigate('/admin/dashboard');
                    } else if (user.role === "PRODUCER") {
                        console.log('Redirecting to producer dashboard');
                        navigate(`/producers/${user._id}/dashboard`);
                    } else if (user.role === "CUSTOMER") {
                        // All customers go to shop - no more first login redirect
                        console.log('Customer - redirecting to shop');
                        navigate('/shop');
                    } else {
                        console.log('Unknown role - redirecting to shop');
                        navigate('/shop');
                    }
                } else {
                    alert('Login failed: Invalid response from server');
                }
            } else {
                alert('Login failed');
            }
        } catch (error) {
            // Extract specific error message from backend
            const errorMessage = error.response?.data?.message || 'Login failed. Please try again.';
            alert(errorMessage);
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    const redirectToRegister = () => {
        navigate('/account/signup');
    }

    return (
        <div className="signin-container">
            <div className="signin-card">
                                   <div className="signin-header">
                       <h1 className="signin-title">Farmers Marketspace</h1>
                       <p className="signin-subtitle">Customer Portal</p>
                   </div>
                
                <form onSubmit={handleSubmitClick} className="signin-form">
                    <div className="form-group">
                        <label htmlFor="userName" className="form-label">
                            Email Address
                        </label>
                        <input
                            type="email"
                            className="form-input"
                            id="userName"
                            placeholder="Enter your email address"
                            value={email}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    
                    <div className="form-group">
                        <label htmlFor="password" className="form-label">Password</label>
                        <div className="password-input-wrap">
                            <input 
                                type={showPassword ? "text" : "password"}
                                className="form-input"
                                id="password"
                                placeholder="Enter your password"
                                value={password}
                                onChange={handleChange}
                                required
                            />
                            <button
                                type="button"
                                className="password-toggle"
                                onClick={() => setShowPassword((prev) => !prev)}
                                aria-label={showPassword ? "Hide password" : "Show password"}
                            >
                                {showPassword ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                        <circle cx="12" cy="12" r="3" />
                                    </svg>
                                ) : (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                                        <line x1="1" y1="1" x2="23" y2="23" />
                                    </svg>
                                )}
                            </button>
                        </div>
                    </div>

                    <div style={{ textAlign: 'right', marginBottom: 16 }}>
                        <button
                            type="button"
                            className="register-link"
                            onClick={() => navigate('/account/forgot-password')}
                            style={{ marginLeft: 0 }}
                        >
                            Forgot password?
                        </button>
                    </div>
                    
                    <button
                        type="submit"
                        className="signin-button"
                        disabled={loading}
                    >
                        {loading ? "Signing in..." : "Sign In"}
                    </button>
                </form>
                
                                   <div className="register-section">
                       <span className="register-text">Don't have an account? </span>
                       <button 
                           className="register-link"
                           onClick={redirectToRegister}
                           type="button"
                       >
                           Sign up here
                       </button>
                   </div>
            </div>
        </div>
    )
}

export default LoginForm;